/** @file Viewport ghost: a proposed document the viewport draws translucent over the real one. */
import type { Doc } from '@pose2d/format/types';
import { createStore } from 'zustand/vanilla';

/** A document drawn as a ghost until cleared; `owner` names the panel that set it, so it clears only its own. */
export interface ViewportGhost {
  owner: string;
  doc: Doc;
  /** Opacity of the ghost's attachments, 0..1. */
  opacity: number;
  /** Overlay layers drawn for the ghost on top of its attachments (overlay tokens of spec §7.2). */
  overlays: readonly ('bones' | 'names' | 'mesh')[];
}

/** At most one ghost; `null` draws nothing extra. Written by panels (auto-rig review), read by the viewport. */
export const ghostStore = createStore<{ ghost: ViewportGhost | null }>()(() => ({ ghost: null }));
